import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { CatalogService } from 'src/app/_services/catalogs/catalog.service';
import { InsertEgresadoRequest } from '../requests/insert-egresado-request';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-adm-egresados-gestion',
  templateUrl: './adm-egresados-gestion.component.html',
  styleUrls: ['./adm-egresados-gestion.component.css']
})
export class AdmEgresadosGestionComponent implements OnInit {

  addEgresadoForm: FormGroup;
  loadPage = false;

  _listaAreas : any;
  _listaDivisiones : any;

  constructor(private formBuilder: FormBuilder,
              private toast : ToastrService,
              private adminService : AdminService,
              private catalogService : CatalogService) 
  {}

  async ngOnInit() {

    this.addEgresadoForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required,
        Validators.minLength(3),
        Validators.maxLength(85)]),
      lastName: new FormControl('', [Validators.required,
      Validators.minLength(3),
      Validators.maxLength(50)]),
      generation: new FormControl('', [Validators.required,
      Validators.minLength(8),
      Validators.maxLength(12)]),
      speciality: new FormControl('', [Validators.required]),
      username: new FormControl('', [Validators.required,
                                      Validators.pattern(/^[^\sñ]+$/),
                                      Validators.maxLength(12),
                                      Validators.minLength(10),
                                      Validators.pattern(/^[a-zA-Z0-9]+$/)
                                    ]),
    });

    await this.loadData();
  }

  trySubmit()
  {
    if(this.addEgresadoForm.invalid)
    {
      this.toast.error('Verifique la información','error');
      return;
    }
    try {
      //assign values
      let request = {} as InsertEgresadoRequest;
      request.nombre = this.f.name.value;
      request.apellido = this.f.lastName.value;
      request.sexo = true;
      request.idArea = this.f.speciality.value;
      request.usuario = this.f.username.value;
      request.usuario=request.usuario.toUpperCase();
      request.password = request.usuario;
      request.generacion = this.f.generation.value;
      
      this.adminService.agregarEgresado(request).subscribe({
        next: (result) => 
        {
          if(result.idUsuario>0)
            this.toast.success(result.mensaje,'');
          else
            this.toast.error(result.mensaje,'');
        },
        error: (error) => {
          this.toast.error('Ocurrio un error con el servidor','error');
        },
        complete: () => 
        {
          this.addEgresadoForm.reset();
        }
    });
    } catch (error) {
      this.toast.error('Ocurrio un error con el servidor','error');
    }
  }

  
  get f() {
    return this.addEgresadoForm.controls;
  }

  async LoadDivisiones() : Promise<boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.catalogService.getDivisiones());
      if(data && data.length>0)
      {
        this._listaDivisiones = data;
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }


  async loadAreas(idDivision: number) : Promise<boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.catalogService.getAreasUTPDivision(idDivision));
      if(data && data.length>0)
      {
        this._listaAreas = data;
        if(this._listaAreas && this._listaAreas.length>0)
        {
          this.loadAreas(this._listaAreas[0]?.idArea);
          this.addEgresadoForm.get('speciality').setValue(this._listaAreas[0]?.idArea);
          return true;
        }
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  async loadData()
  {
    let divloaded = await this.LoadDivisiones();
    if(!divloaded)
    {
      this.toast.error('No se cargaron los datos correctamente, intentalo nuevamente.','Error de conexión');
      return;
    }
    let areasLoaded = await this.loadAreas(this._listaDivisiones[0].idDivision);
    if(!areasLoaded)
    {
      this.toast.error('No se cargaron los datos correctamente, intentalo nuevamente.','Error de conexión');
      return;
    }
    this.loadPage=true;
  }

}
